export const RPM = 'RPM';
export const OPT_RPM1 = 'OPT_RPM1';
export const OPT_RPM2 = 'OPT_RPM2';
